/**
 * Copyright IBM Corp. 2016, 2018
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { useEffect, useRef } from 'react';
/**
 * A custom hook which will call the given callback exactly once when your
 * component is initially rendered and effects are first called
 *
 * @param {Function} callback
 */

export function useEffectOnce(callback) {
  var savedCallback = useRef(callback);
  var effectGuard = useRef(false);
  useEffect(function () {
    savedCallback.current = callback;
  });
  useEffect(function () {
    if (effectGuard.current !== true) {
      effectGuard.current = true;
      savedCallback.current();
    }
  }, []);
}